/* eslint-disable react/prop-types */
import React from 'react'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { withRouting } from '../../common/hooks'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as coachActions from '../../../actions/coachActions'
import * as userActions from '../../../actions/userActions'
import * as reportsActions from '../../../actions/reportsActions'
import Input from '../../common/form/Input'

import CoachOnboardingDetails from './CoachOnboardingDetails'

// ASSETS
import './CoachStats.scss'

const getColor = (value) => {
  switch (value) {
    case 0:
      return '#ed213a'
    case 1:
      return '#fddb10'
    case 2:
      return '#33d9b2'
    default:
      return ''
  }
}

class CoachStats extends React.Component {
  state = {
    coachId: this.props.coach.coach.id,
    status: 'static',
    savedPhone: this.props.coach.coach.phone
      ? this.props.coach.coach.phone
      : null,
    savedPhonePrefix: this.props.coach.coach.phone_prefix
      ? this.props.coach.coach.phone_prefix
      : null,
    savedPhonePrefixCountry: this.props.coach.coach.phone_prefix_country
      ? this.props.coach.coach.phone_prefix_country
      : null,
    savedEmail: this.props.coach.coach.email
      ? this.props.coach.coach.email
      : null,
    email: this.props.coach.coach.email ? this.props.coach.coach.email : null,
    phone: this.props.coach.coach.phone ? this.props.coach.coach.phone : null,
    phonePrefix: this.props.coach.coach.phone_prefix ? this.props.coach.coach.phone_prefix : null,
    phonePrefixCountry: this.props.coach.coach.phone_prefix_country ? this.props.coach.coach.phone_prefix_country : null,
    contactLoader: false,
  }

  render() {
    const { coach, makeLeadCoach, t } = this.props
    const { contactLoader } = this.state
    return (
      <div id='CoachStats'>
        <div className='coach-contact-container'>
          <div className='d-flex justify-content-between align-items-center mb-3'>
            <h4>{t('communities.coachStats.contactInfo')}</h4>
            <span
              role='button'
              tabIndex={0}
              onClick={this._toggleEdit}
              onKeyDown={(e) => e.key === 'Enter' && this._toggleEdit}
              id='contact-info-edit'
            >
              {this.state.status === 'static' ? t('common.edit') : t('common.close')}
            </span>
          </div>

          {this._renderContactInfo(coach, contactLoader)}
        </div>
        {this.props.isExpanded && (
          <CoachOnboardingDetails coachId={coach.coach.id} />
        )}
        {!coach.coach.is_lead_coach && (
          <button
            className='lead-coach-button'
            onClick={() => makeLeadCoach(coach.coach.id)}
          >
            {t('communities.coachStats.makeLeadCoach')}
          </button>
        )}
        <div className='row'>
          <div className='col-6'>
            <h2
              style={{
                color: getColor(coach.completed_express_training.score.value),
              }}
            >
              {coach.completed_express_training.value}
            </h2>
            <p>{t('communities.coachStats.stat.completedOldExpressTraining')}</p>
          </div>
          <div className='col-6'>
            <h2
              style={{
                color: getColor(
                  coach.completed_updated_express_training.score.value
                ),
              }}
            >
              {coach.completed_updated_express_training.value}
            </h2>
            <p>{t('communities.coachStats.stat.completedUpdatedExpressTraining')}</p>
          </div>
        </div>
        <div className='row'>
          <div className='col-6'>
            <h2
              style={{
                color: getColor(coach.events_count.score.value),
              }}
            >
              {coach.events_count.value}
            </h2>
            <p>{t('communities.coachStats.stat.eventsCreated')}</p>
          </div>
          <div className='col-6'>
            <h2
              style={{
                color: getColor(coach.programs_count.score.value),
              }}
            >
              {coach.programs_count.value}
            </h2>
            <p>{t('communities.coachStats.stat.classesCreated')}</p>
          </div>
        </div>
        <div className='row'>
          <div className='col-6'>
            <h2
              style={{
                color: getColor(coach.likes_count.score.value),
              }}
            >
              {coach.likes_count.value}
            </h2>
            <p>{t('communities.coachStats.stat.likesGiven')}</p>
          </div>
          <div className='col-6'>
            <h2
              style={{
                color: getColor(coach.comments_count.score.value),
              }}
            >
              {coach.comments_count.value}
            </h2>
            <p>{t('communities.coachStats.stat.commentsCreated')}</p>
          </div>
        </div>
        <div className='row'>
          <div className='col-6'>
            <h2
              style={{
                color: getColor(coach.private_goal_count.score.value),
              }}
            >
              {coach.private_goal_count.value}
            </h2>
            <p>{t('communities.coachStats.stat.privateGoalsIssued')}</p>
          </div>
          <div className='col-6'>
            <h2
              style={{
                color: getColor(coach.announcements_count.score.value),
              }}
            >
              {coach.announcements_count.value}
            </h2>
            <p>{t('communities.coachStats.stat.announcementsCreated')}</p>
          </div>
        </div>
      </div>
    )
  }

  _handleInputChange = (event) => {
    if (event.phone !== undefined) {
      this.setState({
        phone: event.phone || null,
        phonePrefix: event.phonePrefix || null,
        phonePrefixCountry: event.phonePrefixCountry || null,
      })
    } else {
      const { name, value } = event.target
      this.setState({
        [name]: value ? value : null,
      })
    }
  }

  _toggleEdit = () => {
    if (this.state.status === 'static') {
      this.setState({
        status: 'edit',
      })
    } else {
      this.setState({
        status: 'static',
      })
    }
  }

  _renderContactInfo = (coach, loader) => {
    const { t } = this.props
    if (loader) {
      return <Loader message={t('communities.coachStats.saving')} />
    }
    if (this.state.status === 'static') {
      return (
        <div>
          <p>
            <span>{t('communities.coachStats.emailLabel')}</span>{' '}
            {this.state.savedEmail
              ? this.state.savedEmail
              : t('communities.coachStats.noEmail')}
          </p>
          <p>
            <span>{t('communities.coachStats.phoneLabel')}</span>{' '}
            {this.state.savedPhone
              ? `${this.state.savedPhonePrefix || ''}${this.state.savedPhone}`
              : t('communities.coachStats.noPhone')}
          </p>
        </div>
      )
    } else {
      return (
        <form>
          <table>
            <tbody>
              <tr>
                <td className='input-label'>{t('communities.coachStats.emailLabel')}{' '}</td>
                <td>
                  <input
                    type='email'
                    name='email'
                    value={this.state.email ? this.state.email : ''}
                    placeholder={t('communities.coachStats.noneLabel')}
                    onChange={this._handleInputChange}
                  />
                </td>
              </tr>
              <tr>
                <td className='input-label'>{t('communities.coachStats.phoneLabel')}{' '}</td>
                <td>
                  <Input
                    type='telephone'
                    name='phone'
                    value={this.state.phone ? `${this.state.phonePrefix || ''}${this.state.phone}` : this.state.phonePrefix || ''}
                    onChange={this._handleInputChange}
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <button
            onClick={this._handleSave}
            onKeyDown={(e) => e.key === 'Enter' && this._handleSave}
            id='form-save'
            className='d-flex justify-content-center'
          >
            {t('common.save')}
          </button>
        </form>
      )
    }
  }

  _handleSave = () => {
    if (
      this.state.email === this.state.savedEmail &&
      this.state.phone === this.state.savedPhone &&
      this.state.phonePrefix === this.state.savedPhonePrefix &&
      this.state.phonePrefixCountry === this.state.savedPhonePrefixCountry
    ) {
      this.setState({ status: 'static' })
    } else {
      this.setState({ contactLoader: true })
      this._updateCoach(this.state.coachId)
    }
  }

  _updateCoach = async (id) => {
    const user = {
      id: id,
      phone: this.state.phone,
      phone_prefix: this.state.phonePrefix,
      phone_prefix_country: this.state.phonePrefixCountry,
      email: this.state.email,
    }
    this.props.user_actions.updateUser(user).then((_res) =>
      this.setState({
        status: 'static',
        contactLoader: false,
        savedPhone: this.state.phone,
        savedPhonePrefix: this.state.phonePrefix,
        savedPhonePrefixCountry: this.state.phonePrefixCountry,
        savedEmail: this.state.email,
      })
    )
  }
}

function mapStateToProps(state, _ownProps) {
  return {
    ui: state.ui,
    user: state.user.current_user,
    coaches: state.coaches,
    communities: state.communities.communities,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    coach_actions: bindActionCreators(coachActions, dispatch),
    user_actions: bindActionCreators(userActions, dispatch),
    reports_actions: bindActionCreators(reportsActions, dispatch),
  }
}

CoachStats.propTypes = {
  user_actions: PropTypes.shape({
    updateUser: PropTypes.func,
  }),
  coach: PropTypes.shape({
    coach: PropTypes.shape({
      id: PropTypes.number,
      email: PropTypes.string,
      phone: PropTypes.string,
      phone_prefix: PropTypes.string,
      phone_prefix_country: PropTypes.string,
      is_lead_coach: PropTypes.bool,
    }),
    completed_express_training: PropTypes.shape({
      score: PropTypes.shape({
        value: PropTypes.number,
      }),
      value: PropTypes.string,
    }),
    completed_updated_express_training: PropTypes.shape({
      score: PropTypes.shape({
        value: PropTypes.number,
      }),
      value: PropTypes.string,
    }),
    events_count: PropTypes.shape({
      score: PropTypes.shape({
        value: PropTypes.number,
      }),
      value: PropTypes.number,
    }),
    programs_count: PropTypes.shape({
      score: PropTypes.shape({
        value: PropTypes.number,
      }),
      value: PropTypes.number,
    }),
    likes_count: PropTypes.shape({
      score: PropTypes.shape({
        value: PropTypes.number,
      }),
      value: PropTypes.number,
    }),
    comments_count: PropTypes.shape({
      score: PropTypes.shape({
        value: PropTypes.number,
      }),
      value: PropTypes.number,
    }),
    private_goal_count: PropTypes.shape({
      score: PropTypes.shape({
        value: PropTypes.number,
      }),
      value: PropTypes.number,
    }),
    announcements_count: PropTypes.shape({
      score: PropTypes.shape({
        value: PropTypes.number,
      }),
      value: PropTypes.number,
    }),
  }),
  params: PropTypes.shape({
    communityId: PropTypes.string,
  }),
  setIsOnboardingStepsModalVisible: PropTypes.func,
  makeLeadCoach: PropTypes.func,
  completedSteps: PropTypes.number,
  totalSteps: PropTypes.number,
  isExpanded: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(withRouting(CoachStats)))
